import { render, staticRenderFns } from "./disbursementTabs.vue?vue&type=template&id=2353e2dd&"
import script from "./disbursementTabs.vue?vue&type=script&lang=js&"
export * from "./disbursementTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports